// extracted by mini-css-extract-plugin
export var block = "newsletter-module--block--561c9";
export var categoryTitle = "newsletter-module--categoryTitle--eeddc";
export var error = "newsletter-module--error--16f81";
export var form = "newsletter-module--form--bcbcb";
export var formFooter = "newsletter-module--formFooter--b9539";
export var icon = "newsletter-module--icon--501ae";
export var inputBox = "newsletter-module--inputBox--e8883";
export var listCheckbox = "newsletter-module--listCheckbox--b2ac8";
export var listGrid = "newsletter-module--listGrid--993f8";
export var listItem = "newsletter-module--listItem--9df6f";
export var listRow = "newsletter-module--listRow--3d01e";
export var listRowTop = "newsletter-module--listRowTop--e06da";
export var newsletter = "newsletter-module--newsletter--4d5b5";
export var success = "newsletter-module--success--9c2dc";
export var termsLink = "newsletter-module--termsLink--433f6";
export var title = "newsletter-module--title--a9b11";